import React from 'react';

export const AuthContext = React.createContext({
    name: '',
    email: '',
    userId: '',
    isFreshman: false,
    roles: [],
    isAuthenticated: false,
    jwtToken: '',
    login: (token) => { },
    logout: () => { }
});